import { Square } from '@phosphor-icons/react';

export default Square;
